
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useTests = () => {
  const { toast } = useToast();

  return useQuery({
    queryKey: ["tests"],
    queryFn: async () => {
      try {
        // Direct test query first - let's see if we can get the data
        const { data: testsData, error: testsError } = await supabase
          .from("tests")
          .select("*")
          .order('grade_level');

        if (testsError) {
          console.error("Tests fetch error:", testsError);
          throw testsError;
        }

        if (!testsData || testsData.length === 0) {
          console.error("No tests found in database");
          throw new Error("No tests available");
        }

        console.log("Successfully fetched tests:", testsData);
        return testsData;

      } catch (error: any) {
        console.error("Error in test query:", error);
        toast({
          title: "Error Loading Tests",
          description: error.message || "Failed to load tests",
          variant: "destructive",
        });
        throw error;
      }
    },
    retry: 1,
    gcTime: 0,
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });
};
